<template>
	<div class="content">
		<headerTop></headerTop>
		<div class="swiperImg" :class="detail.show_type==2||detail.show_type==1?'little':''" :style="{backgroundImage:'url('+$index.addurl(detail.background_img)+')'}">
			<div class="videoDivs" v-if="detail.show_type==2||detail.show_type==1" @click.stop="toZb(detail.url)">
				<img src="../../assets/image/bofang.png" alt="" class="bofang" @click.stop="play" v-if="imgStatus">
				<div class="videoDiv" v-if="detail.show_type==2">
					<video id="videoPlay" ref="videoPlay" type="video/mp4" controls="true" class="videoC" :src="$index.addurl(detail.video_file)"></video>
				</div>
				<div class="videoDiv" v-if="detail.show_type==1">
					<img :src="$index.addurl(detail.url_image)" alt="" >
				</div>
			</div>
		</div>
		<div class="center page-content" :style="{animation:animation}">
			<div class="child" v-html="detail.content"></div>
		</div>
	</div>
</template>

<script>
	import router from "../../router";
	import headerTop from '../../components/headerTop.vue'
	export default{
		components: {
			headerTop
		},
		data(){
			return {
				img:'',
				animation:'',
				contents:'',
				detail:{},
				techList:[],
				imgStatus:true,
			}
		},
		created() {
			this.animation = 'detail .4s linear forwards'
			this.getdata();
		},
		methods:{
			play(){
				this.$refs.videoPlay.play();
				this.imgStatus = false;
			},
			toZb(url){
				if(this.detail.show_type==1){
					window.open(url);
				}
			},
			getdata(){
				let id = this.$route.query.id;
				let _this = this;
				_this.$api.user.getLessonInfo({
					id:id,
				}).then(res => {
					if(res.code == 1){
						_this.detail = res.data;
					}
				})
			},
		},
		
	}
</script>
<style scoped>
	.content{
		background-color: #1452DC;
		border-bottom: 1px solid #1452DC;
		/* overflow: hidden; */
	}
</style>
<style scoped lang="scss">
	.little{
		padding: 120px 0 !important;
	}
	.videoDivs{
		position: relative;
		img{
			border-radius: 30px;
		}
		.bofang{
			position: absolute;
			top: calc(50% - 40px);
			left: calc(50% - 40px);
			width: 80px;
			height: 80px;
			cursor: pointer;
			z-index: 99;
		}
	}
	.videoC{
		width: 100%;
		height: 100%;
		z-index: 1000;
	}
	.left{
		align-self: flex-start;
		position: sticky;
		top: 100px;
		.leftD{
			background-color: #fff;
			border-radius: 20px;
			padding: 14px 20px 6px;
			width: 8vw;
			align-self: flex-start;
			z-index: 100;
			background-color: rgba(207, 232, 252, 0.5);
			margin-right: 20px;
			.leftD_child{
				margin: 20px 0;
				padding-bottom: 10px;
				font-size: 16px;
				text-align: center;
				color: #333;
				border-bottom: 1px solid #fff;
			}
			.leftD_child:last-child{
				border: none;
			}
			.leftD_child:hover{
				cursor: pointer;
				color: #1452DC;
				animation: changeTab .2s linear forwards;
			}
		}
	}
	.right{
		flex-grow: 1;
	}
	.swiperImg{
		background-image: url('../../assets/page4/bg1.png');
		background-size: cover;
		background-position: center;
		position: relative;
		padding: 220px 0;
		.videoDiv{
			margin: 0 auto;
			height: 400px;
			width: 900px;
			border-radius: 30px;
			background-color: rgba(255, 255, 255, 0.5);
			img{
				width: 100%;
				height: 100%;
			}
		}
		.lTitle{
			margin-left: 4vw;
			font-size: 30px;
			letter-spacing: 4px;
			color: #fff;
		}
		.bTitle{
			margin-left: 4vw;
			color: #fff;
			font-size: 58px;
			letter-spacing: 4px;
			font-weight: bold;
		}
		.sTitle{
			margin-left: 4vw;
			letter-spacing: 2px;
			font-size: 14px;
			color: #fff;
		}
	}
	.center{
		min-height: 300px;
		margin: 0 auto 100px;
		background-color: #fff;
		// padding: 70px 190px;
		padding: 80px 120px 60px 60px;
		border-radius: 30px;
		position: relative;
		top: -80px;
		
	}
</style>


// WEBPACK FOOTER //
// studydetail.vue?ec28e3ac